import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import about from './About.module.css';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';


function About() {
    return (
        <Container fluid>
            <Helmet><title>About | {process.env.REACT_APP_SITENAME}</title></Helmet>
            <Row>
                <Col>
                    <div className={about.container}>
                        <figure>
                            <img id={about.lydiaphoto} src="img/profilephoto.jpg" alt="Lydia"></img>
                        </figure>                    
                        <div className="centre">                        
                            <h2 className="white">
                                <span>ABOUT</span>
                            </h2>
                        </div>
                    </div>
                </Col>               
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
                        <div id={about.biotitle}>
                            <h5>About Me</h5>
                        </div>
                        <div>
                            <a href="https://www.conservationregister.com/acr-profile-page/2134/"><img id={about.iconimg} src="/img/ICON-accredited-member.jpg" alt="Accredited Member"></img></a>
                        </div>
                        <div className="elegant">
                            <p>Welcome to my page. My name is Lydia Messerschmidt — I am an object conservator working across a wide range of materials and collections. While my specialist area is the conservation and care of organic materials, my practice also includes the treatment of glass and ceramics, metals, and plastics.</p>
                            <p>Over the years, my work has expanded beyond the treatment table. I have developed strong experience in project management for conservation and collections-care projects, coordinating teams, timelines, and technical requirements to ensure objects are cared for thoughtfully and responsibly. I particularly enjoy the collaborative nature of this work, the practical challenges and the problem-solving involved in supporting the care of diverse collections.</p>
                            <p>My approach is grounded in sensitivity to materials, clear communication, and a commitment to preserving cultural heritage with care and integrity.</p>

                            <p>If you're interested in my specialist work with fans and feather objects, I maintain a separate site dedicated entirely to that practice, see <a style={{color:"inherit"}} href="https://fansandfeathers.com">Fans & Feathers</a>.</p>
                        </div>
                        <div id={about.getintouch}>
                            <p>
                                <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>Get in Touch</Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default About;